import { enumeration } from '@dazn/peng-html5-tools-utils';
var ScrubClickType = enumeration({
    SEEK_BACKWARD: 'bar click backward',
    SEEK_FORWARD: 'bar click forward',
    SKIP_BACKWARD: 'skip backward',
    SKIP_FORWARD: 'skip forward',
    KEY_RIGHT: 'fast forward rc nav button',
    KEY_LEFT: 'rewind rc nav button',
});
export { ScrubClickType };
//# sourceMappingURL=ScrubClickType.js.map